import { MyleHelper } from "@/Common/Helpers/MyleHelper";
import { IPatientIdentifiersModel } from "@/Common/Models/Patient/UI/Profile/IPatientIdentifiersModel";
import { HealthCardsView } from "@/Patient/Components/Profile/Identifiers/HealthCardsView";
import { OtherIdentifiersView } from "@/Patient/Components/Profile/Identifiers/OtherIdentifiersView";
import { IPatientProfileIdentifiersProps } from "./IdentifiersEdit";

class IdentifiersView extends React.Component<IPatientProfileIdentifiersProps, any> {
    public render(): JSX.Element {
        var model: IPatientIdentifiersModel = (this.props.Model) ? this.props.Model : null;

        return (
            <div className="patient-prof">
                <div className="scrollable patient-identifiers" data-cy="patient-identifiers-view">
                    <div className="block separated">
                        <div className="flex-container heading">
                            <h3 className="thin-font">{cacheStore.GetString("HealthCard")}</h3>
                        </div>

                        <div className="psingle-column centered">
                            <table>
                                <HealthCardsView healthCards={model.get("HealthCards").toArray()} representant={model.get("Representative")} />
                            </table>
                        </div>
                    </div>
                    <div className="block separated">

                        <div className="flex-container heading">
                            <h3 className="thin-font">{cacheStore.GetString("FileNumbersLabel")}</h3>
                        </div>

                        <div className="psingle-column centered">
                            <table>
                                <tbody>
                                    <tr>
                                        <td className="c1"><span className="form-label">{cacheStore.GetString("Identifier1Label")}</span></td>
                                        <td className="c2 text-break-word"><strong title={model.get("Identifier01")} data-cy="patientProfile-fileNumbers-identifier1">{MyleHelper.ReplaceEmptyString(model.get("Identifier01"))}</strong></td>
                                    </tr>
                                    <tr>
                                        <td className="c1"><span className="form-label">{cacheStore.GetString("Identifier2Label")}</span></td>
                                        <td className="c2 text-break-word"><strong title={model.get("Identifier02")} data-cy="patientProfile-fileNumbers-identifier2">{MyleHelper.ReplaceEmptyString(model.get("Identifier02"))}</strong></td>
                                    </tr>
                                    <tr>
                                        <td className="c1"><span className="form-label">{cacheStore.GetString("Identifier3Label")}</span></td>
                                        <td className="c2 text-break-word"><strong title={model.get("Identifier03")} data-cy="patientProfile-fileNumbers-identifier3">{MyleHelper.ReplaceEmptyString(model.get("Identifier03"))}</strong></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div className="block separated">
                        <div className="flex-container heading">
                            <h3 className="thin-font">{cacheStore.GetString("OtherIdentifierslabel")}</h3>
                        </div>

                        <div className="psingle-column centered">
                            <OtherIdentifiersView identifiers={model.get("OtherIdentifiers").toArray()} />
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    public componentDidMount(): void {
        $(window).trigger("resize");
    }
}

export { IdentifiersView };
